function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "SVGRepo_bgCarrier",
  strokeWidth: 0
});

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "SVGRepo_tracerCarrier",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgUserAvatar = function SvgUserAvatar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    fill: "#000000",
    width: 60,
    height: 60,
    viewBox: "0 0 24 24",
    id: "user-circle-2",
    "data-name": "Flat Color",
    className: "icon flat-color",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, React.createElement("circle", {
    id: "primary",
    cx: 12,
    cy: 12,
    r: 10,
    style: {
      fill: "#571517"
    }
  }), React.createElement("path", {
    id: "secondary",
    d: "M19.37,17.88a8,8,0,0,0-3.43-3.83,5,5,0,1,0-7.88,0,8,8,0,0,0-3.43,3.83A1,1,0,0,0,4.83,19a10,10,0,0,0,14.24.1l.09-.09A1,1,0,0,0,19.37,17.88Z",
    style: {
      fill: "#fff"
    }
  })));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgUserAvatar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/user-avatar.c6881426.svg";
export { ForwardRef as ReactComponent };